/* eslint-disable no-restricted-globals */
// We are deconstructing the `k` variable below to use in the map method
//  as the `label`. It's safe to ignore this eslint rule here.
export const mapEnum = (enumerator: object) => {
  const entries = Object.entries(enumerator);

  return entries.filter(({ 1: v }) => !isNaN(v as number))
    .map(([label, id]) => ({ id, label }));
};
